/* eslint-disable style/no-tabs */
import { useTranslation } from "react-i18next";

function SecurityFailedNotSupported() {
  const { t } = useTranslation("security");

  return (
    <>
      <p>
        {t("security:kyc-failed-not-supported-intro")}
        ;
        {/* We regret to inform you that your recent submission for the verification
				process has been unsuccessful due to the submission of an unsupported
				document. Our process requires specific document types for verification,
				and unfortunately, the document you submitted does not fall within our
				supported document categories. */}
      </p>
      <p>
        {t("security:kyc-failed-not-supported-header")}
        {/* The specific issue identified with your submission is: */}
      </p>
      <div class="w-full h-4" />
      <p>
        <strong>
          {t("security:kyc-failed-not-supported-list-header-1")}
          {" "}
          {/* Unsupported Document: */}
        </strong>
        {t("security:kyc-failed-not-supported-list-item-1")}
        {/* The document you submitted for verification is not among the accepted
				document types outlined in our KYC guidelines. We are unable to process
				documents that do not meet our predefined criteria. */}
      </p>
      <div class="w-full h-4" />
      <p>
        {t("security:kyc-failed-not-supported-instructions")}
        {/* To address this issue and successfully complete your verification,
				please take the following steps: */}
      </p>
      <div class="w-full h-4" />
      <ul>
        <li class="list-disc pl-2 ml-4">
          <strong>
            {t("security:kyc-failed-not-supported-list-header-2")}
            {" "}
            {/* Resubmit a Supported Document: */}
          </strong>
          {t("security:kyc-failed-not-supported-list-item-2-pt1")}
          {" "}
          {/* Please provide a valid
					document that falls within our list of accepted document types for KYC
					verification. Commonly accepted documents include government-issued ID
					cards, passports, driver's licenses, or other documents specified in
          */}
          <a
            href="https://knowledge-base.sentric.com/what-documents-are-accepted-by-idenfy"
            target="_blank"
            rel="noreferrer"
            title={t("security:kyc-failed-documents-link")} // 'What Documents Are Accepted By Idenfy?'
          >
            {t("security:kyc-failed-not-supported-list-item-2-pt2")}
            {" "}
            {/* our guidelines */}
          </a>
        </li>
        <li class="list-disc pl-2 ml-4">
          <strong>
            {t("security:kyc-failed-not-supported-list-header-3")}
            {" "}
            {/* Review Guidelines: */}
          </strong>
          {" "}
          {t("security:kyc-failed-not-supported-list-item-3")}
          {/* Ensure that you carefully review our guidelines to understand the
					specific document requirements and acceptable document types. */}
        </li>
      </ul>
      <div class="w-full h-4" />
      <p>
        {t("security:kyc-failed-not-supported-ending")}
        {/* We look forward to receiving the correct document for your KYC
				verification. */}
      </p>
    </>
  );
}
export default SecurityFailedNotSupported;
